import {html, LitElement, css, TemplateResult} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {
  ABOUT_LABEL,
  BLOG_LABEL,
  NAME_LABEL,
  PROJECTS_LABEL,
  WRITINGS_LABEL,
} from './labels';

@customElement('global-header')
export class GlobalHeaderElement extends LitElement {
  @property({type: String, reflect: true})
  active = '';

  @property({type: Boolean})
  static = false;

  static get styles() {
    return css`
      header {
        align-items: center;
        background: linear-gradient(180deg, #fff 60%, rgba(255, 255, 255, 0));
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        padding: 0.5rem;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 100;
      }

      header h1 {
        color: #222;
        display: inline-block;
        font-size: 1rem;
        font-weight: 700;
        line-height: 1rem;
        margin: 0;
        width: 4rem;
      }

      header h1:lang(ja) {
        width: 6rem;
      }

      nav {
        display: inline-block;
      }

      nav ul {
        display: inline-block;
        list-style: none;
        margin: 0;
        padding: 0;
      }

      nav li {
        border-bottom: solid 2px rgba(0, 0, 0, 0);
        display: inline-block;
        font-size: 0.8rem;
        font-weight: 700;
        margin-left: 0.5rem;
      }

      nav li:first-child {
        margin-left: 0;
      }

      nav li:hover,
      nav li:focus,
      nav li.active {
        outline: 0;
        border-color: inherit;
      }

      nav li a {
        color: inherit;
        text-decoration: inherit;
      }

      @media only screen and (min-width: 330px) {
        header {
          padding: 1rem;
        }

        header h1 {
          width: auto;
        }

        nav ul {
          padding: 2px 0 0;
        }
      }

      @media only screen and (min-width: 420px) {
        header {
          padding: 1rem;
        }

        nav li {
          font-size: 1rem;
        }

        nav ul {
          padding: 4px 0 0;
        }

        header h1 {
          font-size: 1.2rem;
          line-height: 2rem;
        }
      }

      @media only screen and (min-width: 640px) {
        nav li {
          margin-left: 1rem;
        }
      }
    `;
  }

  _linkTemplate(
    path: string,
    label: TemplateResult | string,
    staticLink: boolean
  ) {
    if (staticLink) {
      return html`<a href="/intl/${document.documentElement.lang}/${path}"
        >${label}</a
      >`;
    } else {
      return html`<app-link href="/${path}">${label}</app-link>`;
    }
  }

  render() {
    return html`
      <header>
        ${this._linkTemplate('', html`<h1>${NAME_LABEL()}</h1>`, this.static)}
        <nav>
          <ul>
            <li class="${this.active === 'projects' ? 'active' : ''}">
              ${this._linkTemplate('projects/', PROJECTS_LABEL(), this.static)}
            </li>
            <li class="${this.active === 'writings' ? 'active' : ''}">
              ${this._linkTemplate('writings/', WRITINGS_LABEL(), true)}
            </li>
            <li class="${this.active === 'about' ? 'active' : ''}">
              ${this._linkTemplate('about/', ABOUT_LABEL(), true)}
            </li>
            <li class="${this.active === 'blog' ? 'active' : ''}">
              ${this._linkTemplate('blog/', BLOG_LABEL(), true)}
            </li>
          </ul>
        </nav>
      </header>
    `;
  }
}
